const initial_fields = [
  {
    id: "initial_fields_01",
    before: "an",
    after: "",
    value: "cat\ndog\nrandom animal",
  },
  {
    id: "initial_fields_02",
    before: "",
    after: "",
    value: "illustration\nphoto",
  },
  {
    id: "initial_fields_03",
    before: "",
    after: "",
    value: "white background\nsolid background",
  },
  {
    id: "initial_fields_04",
    before: "",
    after: "",
    value: "--niji\n--ar 3:2\n--ar:1:1\n--v 4\n",
  },
];
export const initial_fieldObjects = [
  {
    id: "initial_fieldObject_id",
    name: "Example",
    fields: initial_fields,
  },
];
